import { connect } from 'react-redux';
import TotalCostAmount from '../components/total-cost-amount';

const mapStateToProps = ({ purchases }) => {
  const purchase = purchases.byId[purchases.current];
  const { costComponents, product, currencyCode, payments, costRange } = purchase;

  return {
    costComponents,
    costs: product.costRange,
    costType: product.costType,
    currencyCode,
    payments,
    currentCostRange: costRange,
  };
};

export default connect(mapStateToProps)(TotalCostAmount);



// WEBPACK FOOTER //
// ./src/desktop/containers/current-total-cost-range.container.js